import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SideNav } from "@govtechsg/sgds-react/SideNav";
import { handleEvtClicks } from "../js/helper";

const scrollToClick = (sectionID, e) => {
  e.preventDefault();
  let sectionSelected = document.querySelector(sectionID);
  sectionSelected.scrollIntoView({ behavior: "smooth" });
  new handleEvtClicks("APIDocs", { APIDocSection: sectionID });
};

const SideNavComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [activeKey, setActiveKey] = useState("");

  const clickButton = (key) => {
    activeKey === key ? setActiveKey("") : setActiveKey(key);
  };

  useEffect(() => {
    if (location === null) {
      clickButton("0");
    } else {
      const currentPath = location.pathname;
      // console.log(currentPath);
      if (currentPath.includes("maps")) {
        setActiveKey("0");
      } else if (currentPath.includes("search")) {
        setActiveKey("1");
      } else if (currentPath.includes("authentication")) {
        setActiveKey("2");
      } else if (currentPath.includes("reversegeocode")) {
        setActiveKey("3");
      } else if (currentPath.includes("routing")) {
        setActiveKey("4");
      } else if (currentPath.includes("bfa")) {
        setActiveKey("5");
      } else if (currentPath.includes("coordinate")) {
        setActiveKey("6");
      } else if (currentPath.includes("themes")) {
        setActiveKey("7");
      } else if (currentPath.includes("nearbytransport")) {
        setActiveKey("8");
      } else if (currentPath.includes("planningarea")) {
        setActiveKey("9");
      } else if (currentPath.includes("populationquery")) {
        setActiveKey("10");
      } else if (currentPath.includes("staticmap")) {
        setActiveKey("11");
      } else if (currentPath.includes("mcp")) {
        setActiveKey("12");
      }
    }
  }, [location]);

  useEffect(() => {
    if (!location.hash) {
      return;
    }

    const sectionId = location.hash.replace("#", "");
    const section = document.getElementById(sectionId);

    if (!section) {
      return;
    }

    const offset = 90;
    const targetTop = section.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({ top: targetTop, behavior: "smooth" });
  }, [location.pathname, location.hash]);

  const handleSideNavClick = (event) => {
    const anchor = event.target.closest("a[href]");
    if (!anchor) return;

    const href = anchor.getAttribute("href");
    if (!href || href.startsWith("http") || href.startsWith("mailto:") || href.startsWith("#")) {
      return;
    }

    const [pathPart, hashPart] = href.split("#");
    const normalizedPath = pathPart ? (pathPart.startsWith("/") ? pathPart : `/${pathPart}`) : location.pathname;
    const nextUrl = `${normalizedPath}${hashPart ? `#${hashPart}` : ""}`;

    if (nextUrl === `${location.pathname}${location.hash}`) {
      return;
    }

    event.preventDefault();
    navigate(nextUrl);
  };

  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleCollapse = (e) => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <SideNav
      id="NavStart"
      // activeNavLinkKey={activeLinkKey}
      activeKey={activeKey}
      alwaysOpen
      onClick={handleSideNavClick}
    >
      <SideNav.Item
        eventKey="0"
        style={{ marginBottom: "0px", borderRadius: "10px" }}
      >
        <SideNav.Button
          onClick={() => clickButton("0")}
          style={{ width: "100%" }}
        >
          <div className="d-flex justify-content-between">Maps Services</div>
        </SideNav.Button>
        <SideNav.Collapse>
          <>
            <SideNav.Link eventKey="nl-1" href="maps/#baseMap">
              Basemap
            </SideNav.Link>
            <SideNav.Link eventKey="nl-2" href="maps/#miniMap">
              Minimap
            </SideNav.Link>
            <SideNav.Link eventKey="nl-3" href="maps/#advancedMiniMap">
              Advanced Minimap
            </SideNav.Link>
            <SideNav.Link eventKey="nl-4" href="maps/#staticMap">
              Staticmap
            </SideNav.Link>
          </>
        </SideNav.Collapse>
      </SideNav.Item>
      <SideNav.Item eventKey="1" style={{ borderRadius: "10px" }}>
        <SideNav.Button onClick={() => clickButton("1")}>
          <SideNav.Link eventKey="nl-5" href="search">
            Search
          </SideNav.Link>
        </SideNav.Button>
      </SideNav.Item>
      <SideNav.Item eventKey="2" style={{ borderRadius: "10px" }}>
        <SideNav.Button onClick={() => clickButton("2")}>
          <SideNav.Link eventKey="nl-6" href="authentication">
            Authentication
          </SideNav.Link>
        </SideNav.Button>
      </SideNav.Item>
      <SideNav.Item eventKey="3">
        <SideNav.Button onClick={() => clickButton("3")}>
          Reverse Geocode
        </SideNav.Button>
        <SideNav.Collapse>
          <>
            <SideNav.Link eventKey="nl-1" href="reversegeocode/#svy21">
              SVY21 - Singapore TM
            </SideNav.Link>
            <SideNav.Link eventKey="nl-2" href="reversegeocode/#wgs84">
              WGS84 - World Geodetic System 1984
            </SideNav.Link>
          </>
        </SideNav.Collapse>
      </SideNav.Item>
      <SideNav.Item eventKey="4">
        <SideNav.Button onClick={() => clickButton("4")}>
          Routing
        </SideNav.Button>
        <SideNav.Collapse>
          <>
            <SideNav.Link eventKey="nl-1" href="routing/#publicTransport">
              Public Transport
            </SideNav.Link>
            <SideNav.Link eventKey="nl-2" href="routing/#walkdrivecycle">
              Walk/Drive/Cycle
            </SideNav.Link>
          </>
        </SideNav.Collapse>
      </SideNav.Item>
      {/* <SideNav.Item eventKey="5">
        <SideNav.Button onClick={() => clickButton("5")}>BFA</SideNav.Button>
      </SideNav.Item> */}
      <SideNav.Item eventKey="5" style={{ borderRadius: "10px" }}>
        <SideNav.Button onClick={() => clickButton("5")}>
          <SideNav.Link eventKey="nl-5" href="bfa">
            Barrier-Free Access
          </SideNav.Link>
        </SideNav.Button>
      </SideNav.Item>
      <SideNav.Item eventKey="6">
        <SideNav.Button onClick={() => clickButton("6")}>
          Coordinate Converters
        </SideNav.Button>
        <SideNav.Collapse>
          <>
            <SideNav.Link eventKey="nl-1" href="coordinate/#to4326">
              4326(WGS84) to 3857
            </SideNav.Link>
            <SideNav.Link eventKey="nl-2" href="coordinate/#conv4326to3414">
              4326(WGS84) to 3414(SVY21)
            </SideNav.Link>
            <SideNav.Link eventKey="nl-3" href="coordinate/#conv3414to3857">
              3414(SVY21) to 3857
            </SideNav.Link>
            <SideNav.Link eventKey="nl-4" href="coordinate/#conv3414to4326">
              3414(SVY21) to 4326(WGS84)
            </SideNav.Link>
            <SideNav.Link eventKey="nl-5" href="coordinate/#conv3857to3414">
              3857 to 3414(SVY21)
            </SideNav.Link>
            <SideNav.Link eventKey="nl-6" href="coordinate/#conv3857to4326">
              3857 to 4326(WGS84)
            </SideNav.Link>
          </>
        </SideNav.Collapse>
      </SideNav.Item>
      <SideNav.Item eventKey="7">
        <SideNav.Button onClick={() => clickButton("7")}>Themes</SideNav.Button>
        <SideNav.Collapse>
          <>
            <SideNav.Link eventKey="nl-1" href="themes/#checkThemeStatus">
              Check Theme Status
            </SideNav.Link>
            <SideNav.Link eventKey="nl-2" href="themes/#getThemesInfo">
              Get Themes Info
            </SideNav.Link>
            <SideNav.Link eventKey="nl-3" href="themes/#getAllThemesInfo">
              Get All Themes Info
            </SideNav.Link>
            <SideNav.Link eventKey="nl-4" href="themes/#retrieveTheme">
              Retrieve Theme
            </SideNav.Link>
            <SideNav.Link eventKey="nl-5" href="themes/#retrieveThemeExtent">
              Retrieve Theme - With Extents
            </SideNav.Link>
          </>
        </SideNav.Collapse>
      </SideNav.Item>

      <SideNav.Item eventKey="8" style={{ borderRadius: "10px" }}>
        <SideNav.Button onClick={() => clickButton("8")}>
          <SideNav.Link eventKey="nl-5" href="nearbytransport">
            Nearby Transport
          </SideNav.Link>
        </SideNav.Button>
      </SideNav.Item>

      <SideNav.Item eventKey="9">
        <SideNav.Button onClick={() => clickButton("9")}>
          Planning Area
        </SideNav.Button>
        <SideNav.Collapse>
          <>
            <SideNav.Link
              eventKey="nl-1"
              href="planningarea/#planningAreaPolygon"
            >
              Planning Area Polygon
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-2"
              href="planningarea/#namesofPlanningArea"
            >
              Names of Planning Area
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-3"
              href="planningarea/#planningAreaQuery"
            >
              Planning Area Query
            </SideNav.Link>
          </>
        </SideNav.Collapse>
      </SideNav.Item>
      <SideNav.Item eventKey="10">
        <SideNav.Button onClick={() => clickButton("10")}>
          Population Query
        </SideNav.Button>
        <SideNav.Collapse>
          <>
            <SideNav.Link
              eventKey="nl-1"
              href="populationquery/#economicStatusData"
            >
              Economic Status Data
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-2"
              href="populationquery/#educationStatusData"
            >
              Education Status Data
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-3"
              href="populationquery/#ethnicDistribution"
            >
              Ethnic Distribution
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-4"
              href="populationquery/#workIncomeForHouseHold"
            >
              Work Income For Household (Monthly)
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-5"
              href="populationquery/#householdSizeData"
            >
              Household Size Data
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-6"
              href="populationquery/#householdStructureData"
            >
              Household Structure Data
            </SideNav.Link>
            <SideNav.Link eventKey="nl-7" href="populationquery/#incomeFrWork">
              Income From Work Data
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-8"
              href="populationquery/#industryOfPopulationData"
            >
              Industry of population Data
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-9"
              href="populationquery/#languageLiteracyData"
            >
              Language Literacy Data
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-10"
              href="populationquery/#maritalStatusData"
            >
              Marital Status Data
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-11"
              href="populationquery/#modeOfTransportSchool"
            >
              Mode of Transport to School Data
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-12"
              href="populationquery/#modeOfTransportWork"
            >
              Mode of Transport to work Data
            </SideNav.Link>
            <SideNav.Link eventKey="nl-14" href="populationquery/#ageData">
              Age Data
            </SideNav.Link>
            <SideNav.Link eventKey="nl-15" href="populationquery/#religionData">
              Religion Data
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-16"
              href="populationquery/#spokenLangData"
            >
              Spoken Language Data
            </SideNav.Link>
            <SideNav.Link eventKey="nl-17" href="populationquery/#tenancyData">
              Tenancy Data
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-18"
              href="populationquery/#dwellingTypeHouseholdData"
            >
              Dwelling Type Household Data
            </SideNav.Link>
            <SideNav.Link
              eventKey="nl-19"
              href="populationquery/#dwellingTypePopulationData"
            >
              Dwelling Type Population Data
            </SideNav.Link>
          </>
        </SideNav.Collapse>
      </SideNav.Item>
      <SideNav.Item eventKey="11" style={{ borderRadius: "10px" }}>
        <SideNav.Button onClick={() => clickButton("11")}>
          <SideNav.Link eventKey="nl-5" href="staticmap">
            Static Map
          </SideNav.Link>
        </SideNav.Button>
      </SideNav.Item>
      <SideNav.Item eventKey="12">
        <SideNav.Button onClick={() => clickButton("12")}>
          MCP
        </SideNav.Button>
        <SideNav.Collapse>
          <>
            <SideNav.Link eventKey="nl-1" href="mcp/#mcp-quickstart">
              How MCP Works
            </SideNav.Link>
            <SideNav.Link eventKey="nl-2" href="mcp/#mcp-authentication">
              Authentication
            </SideNav.Link>
            <SideNav.Link eventKey="nl-3" href="mcp/#mcp-connect">
              Connect to the MCP server
            </SideNav.Link>
            <SideNav.Link eventKey="nl-4" href="mcp/#mcp-tools">
              Tools
            </SideNav.Link>
            <SideNav.Link eventKey="nl-5" href="mcp/#mcp-security">
              Security
            </SideNav.Link>
            <SideNav.Link eventKey="nl-6" href="mcp/#mcp-troubleshooting">
              Troubleshooting
            </SideNav.Link>
            <SideNav.Link eventKey="nl-7" href="mcp/#mcp-quick-reference">
              Reference
            </SideNav.Link>
          </>
        </SideNav.Collapse>
      </SideNav.Item>
      {/* <SideNav.Item eventKey='9'>
            <SideNav.Button onClick={() => clickButton('9')}>
              Helper Libraries
            </SideNav.Button>
            <SideNav.Collapse>
              <>
                <SideNav.Link eventKey='nl-1' href='#leaflet'>
                  Leaflet
                </SideNav.Link>
                <SideNav.Link eventKey='nl-2' href='#leafletDraw'>
                  Leaflet.draw
                </SideNav.Link>
                <SideNav.Link eventKey='nl-3' href='#esriLeaflet'>
                  ESRI Leaflet
                </SideNav.Link>
                <SideNav.Link eventKey='nl-4' href='#turfjs'>
                  Turf.js
                </SideNav.Link>
                <SideNav.Link eventKey='nl-5' href='#openlayers'>
                  OpenLayers
                </SideNav.Link>
                <SideNav.Link eventKey='nl-6' href='#'>
                  Github/Community/General Repositories, ios, android, new OneMap API<br />
                  authentication module (to remove)
                </SideNav.Link>
              </>
            </SideNav.Collapse>
          </SideNav.Item> */}
    </SideNav>
  );
};

export default SideNavComponent;
